// import { STRAPI_URL, STRAPI_TOKEN } from '../config/constants';

// class StrapiAPI {
//     constructor() {
//         this.baseURL = STRAPI_URL;
//         this.token = STRAPI_TOKEN;
//     }

//     // Generic GET request
//     async get(endpoint, params = '') {
//         try {
//             const response = await fetch(`${this.baseURL}${endpoint}${params}`, {
//                 method: 'GET',
//                 headers: {
//                     'Content-Type': 'application/json',
//                     ...(this.token && { Authorization: `Bearer ${this.token}` }),
//                 },
//             });

//             if (!response.ok) {
//                 throw new Error(`HTTP error! status: ${response.status}`);
//             }

//             const data = await response.json();
//             return data;
//         } catch (error) {
//             console.error('Error fetching data:', error);
//             throw error;
//         }
//     }

//     // Generic POST request
//     async post(endpoint, body) {
//         try {
//             const response = await fetch(`${this.baseURL}${endpoint}`, {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json',
//                     ...(this.token && { Authorization: `Bearer ${this.token}` }),
//                 },
//                 body: JSON.stringify(body),
//             });

//             if (!response.ok) {
//                 throw new Error(`HTTP error! status: ${response.status}`);
//             }

//             const data = await response.json();
//             return data;
//         } catch (error) {
//             console.error('Error posting data:', error);
//             throw error;
//         }
//     }

//     // Get media URL
//     getMediaURL(media) {
//         if (!media) return null;

//         // Handle both Strapi v3 and v4 media structure
//         const url = media.url || media.attributes?.url;

//         if (url?.startsWith('http')) {
//             return url;
//         }

//         return `${this.baseURL}${url}`;
//     }

//     // Get all items from a collection
//     async getAll(collection, params = '?populate=*') {
//         return await this.get(`/api/${collection}`, params);
//     }

//     // Get single item by ID
//     async getOne(collection, id, params = '?populate=*') {
//         return await this.get(`/api/${collection}/${id}`, params);
//     }
// }

// export default new StrapiAPI();


import { STRAPI_URL, STRAPI_TOKEN } from '../config/constants';

class StrapiAPI {
    constructor() {
        this.baseURL = STRAPI_URL;
        this.token = STRAPI_TOKEN;
    }

    // Generic GET request
    async get(endpoint, params = '') {
        try {
            const response = await fetch(`${this.baseURL}${endpoint}${params}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    ...(this.token && { Authorization: `Bearer ${this.token}` }),
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    // Generic POST request
    async post(endpoint, body) {
        try {
            const response = await fetch(`${this.baseURL}${endpoint}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...(this.token && { Authorization: `Bearer ${this.token}` }),
                },
                body: JSON.stringify(body),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error posting data:', error);
            throw error;
        }
    }

    // Get media URL
    getMediaURL(media) {
        if (!media) return null;

        // Handle both Strapi v3 and v4 media structure
        const url = media.url || media.attributes?.url;

        if (url?.startsWith('http')) {
            return url;
        }

        return `${this.baseURL}${url}`;
    }

    // Get all items from a collection
    async getAll(collection, params = '?populate=*') {
        return await this.get(`/api/${collection}`, params);
    }

    // Get single item by ID
    async getOne(collection, id, params = '?populate=*') {
        return await this.get(`/api/${collection}/${id}`, params);
    }

    // Get single item by slug
    // In StrapiAPI class
    // Get single item by slug
    // Get single item by slug
    async getOneBySlug(collection, slug, params = 'populate=*') {
        // Remove leading ? or & from params if present
        const cleanParams = params.replace(/^[?&]/, '');

        // Construct the filter with proper parameter separation
        const filters = `?filters[slug][$eq]=${encodeURIComponent(slug)}&${cleanParams}`;

        const response = await this.get(`/api/${collection}`, filters);

        // Return the full response with the first item as data
        return {
            data: response.data?.[0] || null,
            meta: response.meta
        };
    }
}

export default new StrapiAPI();